import React, { useState, useEffect, useCallback } from 'react';
import { Table } from '@b-design/fusion';
import { appMemberColumns, renderActionItem } from './const';
import $i18n from '@/i18n';
import Space from '@/components/Space';
import PaginationComponent from '@/components/PaginationComponent';
import Requests from '@/services/request';
import './index.less';
import { history } from 'ice';
import { queryStringify, getQueryStringArgs } from '@/utils/url-parse';

interface Completed {
  contentHeight: number
}
const Completed: React.FC<Completed> = ({ contentHeight }) => {
  const { spaceId } = getQueryStringArgs();
  const [column, setColumns] = useState<any[]>(appMemberColumns(spaceId));
  const [dataSource, setDataSource] = useState({ list: [], total: 0 });
  const [loading, setLoading] = useState(false);

  // 分页参数
  const [paginationValue, setPaginationValue] = useState<
    Record<'currentPage' | 'pageSize', number>
  >({
    currentPage: 1,
    pageSize: 10,
  });

  const changeRouter = (record) => {
    history?.push(
      `/approvals/detail?${queryStringify({
        spaceId: spaceId,
        approveId: record.approveId,
        defaultActiveKey: 'Completed',
      })}`,
    );
  };

  useEffect(() => {
    const actionRender = {
      title: $i18n.get({ id: 'aopf.pages.member.columnsAction', dm: '操作' }),
      dataIndex: 'action',
      width: 100,
      cell: (_value, _index, record) => (
        <Space style={{ color: 'var(--superapp-primary-1)' }}>
          <div onClick={() => changeRouter(record)}>
            {renderActionItem({
              icon: 'view--outline',
              content: $i18n.get({
                id: 'aopf.pages.approvals.columnsActionView',
                dm: '查看',
              }),
            })}
          </div>
        </Space>
      ),
    };
    setColumns([...appMemberColumns(spaceId), actionRender]);
    // 查下已完成审批列表
    // Requests.get('/rest/intercnn/approve/query',{currentPage: 1,pageSize: 10,status:"HANDEL" }).then((res)=>{
    //   if(res){
    //     const { list = [], total } = res;
    //     setDataSource({ list, total });
    //   }
    // });
  }, []);
  const queryCompleted = useCallback(
    (params = { status: 'FINISHED', currentPage: 1, pageSize: 10, approveTarget: spaceId }) => {
      if (!spaceId) {
        return;
      };
      setLoading(true);
      Requests.get('/rest/intercnn/approve/query', { ...params }).then((data) => {
        const { list = [], total } = data;
        if (data) {
          setDataSource({ list, total });
          setLoading(false);
        }
      });
    },
    [spaceId],
  );

  useEffect(() => {
    queryCompleted({ status: 'FINISHED', ...paginationValue, approveTarget: spaceId });
  }, [paginationValue, queryCompleted, spaceId]);

  return (
    <div className="list-content">
      <Table.StickyLock
        columns={column}
        dataSource={dataSource?.list}
        fixedHeader
        maxBodyHeight={contentHeight - 48}
        rowkey="approveId"
        loading={loading}
      />
      <div className="pagenation-container">
        <PaginationComponent
          total={dataSource?.total}
          current={paginationValue?.currentPage}
          pageSize={paginationValue?.pageSize}
          onPageChange={(current, pageSize) => {
            setPaginationValue({
              currentPage: current,
              pageSize,
            });
          }}
        />
      </div>
    </div>
  );
};
export default Completed;
